export const path2doctype = (path) => {
    let fileType = '-';
    if (path.includes('foreløpig'))
        return 'hovedrapport';
    if (path.includes('endelig'))
        return 'hovedrapport';
    if (path.includes('tabelloversikt'))
        return 'tabelloversikt';
    if (path.includes('formler'))
        return 'formler';
    if (path.includes('masterfil'))
        return 'masterfil';
    if (path.includes('sektorrangeringer'))
        return 'sektorrangeringer';
    else
        return 'annet';
};
